import ifTag from './If/index';
import forTag from './For/index';

const tags = {
  if: ifTag,
  for: forTag
};

export default tags;
